import ComparisonPie from "./comparison-pie";

export default ComparisonPie;